import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccountGroup } from '../../../../core/model/account-group/account-group.model';
import { Product } from '../../../../core/model/account-group/product.model';
import { SourceAppService } from '../../../../core/services/source-app.service';

/**
 * Presentational component - displays account group and its products / accounts.
 *
 * Emits two events:
 * - onAccountGroupClick - toggle account group visibility
 * - onProductEnableToggle - toggle product enabled status
 */
@Component({
    selector: 'ssf-account-group',
    template: require('./account-group.component.html'),
    styles: [require('./account-group.component.scss')]
})
export class AccountGroupComponent {
    @Input() accountGroup: AccountGroup;

    @Output() onAccountGroupClick = new EventEmitter();
    @Output() onProductEnableToggle = new EventEmitter();
    public i18n = 'SHARED.ACCOUNT-GROUP.';

    constructor(public sourceService: SourceAppService) {}

    onAccountGroupToggle(): void {
        this.onAccountGroupClick.emit(this.accountGroup);
    }

    onProductToggle(product: Product): void {
        if (!this.sourceService.isFromCps()) {
            this.onProductEnableToggle.emit({accountGroup: this.accountGroup, product});
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/account-group/account-group.component.ts